import api from './axios';

export const getSidebarConfig = async () => {
  const response = await api.get('/api/sidebar-config');
  return response.data;
};

export const getCompanyDashboard = async (companyId) => {
  const response = await api.get(`/api/dashboard/company/${companyId}`);
  return response.data;
};

/** @deprecated use getCompanyDashboard */
export const getMotherCompanyDashboard = async () => {
  const response = await api.get('/api/dashboard/mother-company');
  return response.data;
};

/** @deprecated use getCompanyDashboard */
export const getSisterCompanyDashboard = async (companyId) => {
  const response = await api.get(`/api/dashboard/sister-company/${companyId}`);
  return response.data;
};
